<!-- src/components/device/commands/ValeurRapportee.vue -->
<!--
  Ce que la carte APPLIQUE pour un réglage chiffré (sensibilité au choc, intervalles), partagé
  admin/client — même règle que ChoixBinaire pour les réglages à deux états (02/10/2026) :
    - la valeur affichée est celle que la carte RAPPORTE (`reported_config`), pas la demandée ;
    - demandé ≠ rapporté : badge « en attente de la carte », avec la valeur demandée ;
    - jamais rapporté : on le dit, plutôt qu'afficher la demande comme si elle était appliquée.
  Le curseur ou le menu au-dessus garde, lui, la valeur qu'on s'apprête à envoyer.
-->
<template>
  <p class="mt-1 text-xs text-gray-600">
    <template v-if="connu">
      {{ $t('reglage.applique') }} <strong>{{ libelle(rapporte) }}</strong>
      <span v-if="enAttente"
            class="ml-1 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
        {{ $t('reglage.enAttente', { choix: libelle(demande) }) }}
      </span>
    </template>
    <span v-else class="text-gray-500">{{ $t('reglage.nonRapporte') }}</span>
  </p>
</template>

<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'ValeurRapportee',
  props: {
    rapporte: { default: null },
    demande:  { default: null },
    // Mise en forme d'une valeur (« 15 min », « Haute »…) ; par défaut, la valeur brute.
    libelle:  { type: Function, default: v => String(v) }
  },
  setup(props) {
    const connu = computed(() => props.rapporte !== null && props.rapporte !== undefined && props.rapporte !== '');
    const enAttente = computed(() => connu.value && props.demande !== null && props.demande !== undefined
      && String(props.demande) !== String(props.rapporte));
    return { connu, enAttente };
  }
});
</script>
